import { FC } from "react";
import { ReportVersionFieldsFragment } from "app/api/graph/types";
import { formatISODate } from "app/util/format";
import { DetailsTable } from "app/component/report-version/component/part/content/DetailsTable";
import { testTypeLabel } from "app/api/graph/strings";
import { notEmpty } from "app/util/array";

type Props = { version: ReportVersionFieldsFragment };

export const TestDetails: FC<Props> = ({ version }) => (
    <DetailsTable
        details={[
            ["Test name", version.testName],
            [
                "Test dates",
                `Consultancy was performed between ${formatISODate(version.testPerformedFrom)} and ${formatISODate(
                    version.testPerformedTo,
                )} inclusive`,
            ],
            [
                "Test type",
                version.testTypes != null && version.testTypes.length > 0
                    ? version.testTypes
                          .filter(notEmpty)
                          .map((testType) => testTypeLabel(testType))
                          .join(", ")
                    : "-",
            ],
            ["Application version", version.testApplicationVersion ?? "-"],
            ["Server version", version.testServerVersion ?? "-"],
            ["Hostname", version.testHostname ?? "-"],
            ["Effort days", version.testEffortDays != null ? version.testEffortDays.toFixed() : "-"],
        ]}
    />
);
